import { Feature } from '../..';

export const getDatabaseConfiguration = async () => Feature.NotImplemented;
